import { NgModule } from '@angular/core';
import { ButtonNavSharedComponent } from './button-nav.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        ButtonNavSharedComponent,
    ],
    imports: [
        IconSharedModule
    ],
    exports: [
        ButtonNavSharedComponent
    ]
})
export class ButtonNavSharedModule {}
